export default __webpack_public_path__ + "static/media/microservices-preview.95e6462c.png";